import React, { Dispatch, SetStateAction, useRef } from 'react'
import { Image, ImageSourcePropType, ScrollView, View } from 'react-native'
import { ATLAtomIcon, ATLAtomIconButton, ATLTextBody, TextAlignmentEnum } from '@appsimples/atlantica-react-native'
import { icons } from '../../constants/searchAssets'
import { screenWidth } from '../../constants/dimensions'
import { atlTheme } from '../../atlTheme'
import styled from 'styled-components/native'
import { useGlobal } from '../../global/useGlobal'
import { Loading } from '../../components/loading/Loading'
import { TouchableOpacity } from 'react-native-gesture-handler'
import { goToNotificationScreen } from '../../constants/AppModules'

interface NotificationListItemProps {
  itemId: string
  leftIcon?: ImageSourcePropType
  title?: any
  description?: string
  setScrollEnabled: Dispatch<SetStateAction<boolean>>
  updateDataOnDismiss: (id: string) => void
  index: number
  group: string
}

const SwipeableListItemContainer = styled.View`
  justify-content: center;
  width: ${screenWidth}px;
`
const BackgroundView = styled.View`
  position: absolute;
  z-index: -1;
  top: 0;
  bottom: 0;
  left: 0;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${atlTheme.ColorBackground};
  width: ${screenWidth}px;
`

const ForegroundItemContainer = styled.View`
  width: ${screenWidth}px;
  background-color: ${atlTheme.ColorSurface};
  flex-direction: row;
  padding-vertical: 4px;
  padding-horizontal: 16px;
  justify-content: space-between;
`

const IconAndTextContainer = styled<any>(TouchableOpacity)`
  flex-direction: row;
  width: ${props => props.width}px;
`

const TextContainer = styled.View`
  flex-direction: column;
  padding-right: ${atlTheme.SpacingBase}px;
`

const DeleteIconContainer = styled<any>(View)`
  align-self: center;
`

const LeftIconContainer = styled.Image`
  margin-top: ${atlTheme.SpacingAtomic}px;
`

export const NotificationListItem: React.FunctionComponent<NotificationListItemProps> = props => {
  const iconsWithMarginWidth = 72
  const iconAndTextWidth = screenWidth - iconsWithMarginWidth
  const [notifications] = useGlobal('notificationsList')
  const isLastItem = props.index === notifications?.length - 1
  const scrollRef = useRef()

  const dismiss = () => {
    props.updateDataOnDismiss(props.itemId)
  }

  return notifications ? (
    <SwipeableListItemContainer>
      <BackgroundView
        style={
          isLastItem && {
            borderBottomRightRadius: atlTheme.BorderRadiusCard,
            borderBottomLeftRadius: atlTheme.BorderRadiusCard,
          }
        }
      >
        <ATLAtomIcon source={icons.delete} size={atlTheme.SizeIconBase} />
      </BackgroundView>
      <ScrollView
        horizontal={true}
        style={{ width: screenWidth }}
        pagingEnabled
        showsHorizontalScrollIndicator={false}
        onMomentumScrollEnd={event => event.nativeEvent.contentOffset.x > 0 && dismiss()}
        onScroll={event => event.nativeEvent.contentOffset.x.toFixed(0) === screenWidth.toFixed(0) && dismiss()}
        ref={scrollRef}
        scrollEventThrottle={1}
      >
        <ForegroundItemContainer
          style={
            isLastItem && {
              borderBottomRightRadius: atlTheme.BorderRadiusCard,
              borderBottomLeftRadius: atlTheme.BorderRadiusCard,
            }
          }
        >
          <IconAndTextContainer onPress={() => goToNotificationScreen(props.group)} width={iconAndTextWidth}>
            <LeftIconContainer source={props.leftIcon} />
            <TextContainer>
              <ATLTextBody
                verticalMargin={0.1}
                labelBaseProps={{
                  multilineLimit: 10,
                  fontSize: atlTheme.FontSizeAuxiliary,
                  textColor: atlTheme.ColorBrand1Default,
                }}
                textAlignment={TextAlignmentEnum.left}
              >
                {props.title}
              </ATLTextBody>
              <ATLTextBody verticalMargin={0.1} labelBaseProps={{ multilineLimit: 10 }}>
                {props.description}
              </ATLTextBody>
            </TextContainer>
          </IconAndTextContainer>
          <DeleteIconContainer>
            <ATLAtomIconButton
              onPress={() => {
                scrollRef.current.scrollToEnd({ animated: true })
              }}
              buttonSize={atlTheme.SizeIconBase}
              buttonColor={atlTheme.ColorSurface}
              iconColor={atlTheme.ColorMediumContrast}
              icon={icons.dismiss}
            />
          </DeleteIconContainer>
        </ForegroundItemContainer>
        <View style={{ width: screenWidth }} />
      </ScrollView>
    </SwipeableListItemContainer>
  ) : (
    <Loading />
  )
}
